










import { Component, Vue, Prop } from 'vue-property-decorator';

interface ITransferTableItem {
    isSelected: boolean,
    rowNumber: number,
    sourceFormCode: string,
    targetFormCode: string | null,
    isError: boolean
}


@Component({
    name: 'c-budget-forms-copy-rows',
})

export default class CBudgetFormsCopyRows extends Vue {
    @Prop({
        required: true,
    })
    private header!: any;

    @Prop({
        required: true,
    })
    private budgetForm!: any;

    @Prop({
        required: true,
    })
    private categoryFieldNames!: any;

    @Prop({
        required: true,
    })
    private uuidv4!: any;

    @Prop({
        required: false,
        default: false
    })
    private isPaidTab!: any;

    @Prop({
        required: true,
    })
    private isHasDecodeTable!: boolean;

    @Prop({
        required: true,
    })
    private getErrText!: any;

    @Prop({
        required: true,
    })
    private makeToast!: any;

    private copyBtnDisabled: boolean = false;

    private getText(txt: string): string {
        let text = '';
        const linkToTranslations = 'modules.budget_request.copy_rows.' + txt;
        text = this.$t(linkToTranslations) as string;
        return text;
    }

    private onCopyDataClicked() {
        if (!this.isFomHasSelectedCats()) return;
        if (this.isHasSelectedNewRows()) {
            this.makeToast('danger', this.getText('copy_error'), this.getText('need_to_save'));
            return;
        }
        this.fillEmptyNames();
        this.addNewRows()
        this.$emit('updtHeader')
    }

    private isFomHasSelectedCats(): boolean {
        const isHasSelectedItems = this.budgetForm.find((row: any) => row.itemToDelete) !== undefined;
        return isHasSelectedItems;
    }

    private isHasSelectedNewRows(): boolean {
        const isHasSelectedNewRow = this.budgetForm.find((row: any) => row.itemToDelete && row.id < 0) !== undefined;
        return isHasSelectedNewRow
    }

    private fillEmptyNames() {
        const kk_field = this.categoryFieldNames.kk;
        const ru_field = this.categoryFieldNames.ru;
        this.budgetForm.forEach((row: any) => {
            row[kk_field] = kk_field in row && row[kk_field] ? row[kk_field] : '';
            row[ru_field] = ru_field in row && row[ru_field] ? row[ru_field] : '';
        })
    }

    private addNewRows(): void {
        const newBudgetForm: Array<any> = [];
        this.budgetForm.forEach((row: any) => {
            const newRow = JSON.parse(JSON.stringify(row))
            if (row.itemToDelete) {
                this.addNewNames(newRow);
                this.$set(newRow, 'old_category_id', row.category_id);
                this.$set(newRow, 'category_id', this.uuidv4());
                this.$set(newRow, 'old_id', row.id);
                this.$set(newRow, 'id', null);
                newBudgetForm.push(newRow);
            }
        })

        this.saveCopiedRows(newBudgetForm);
    }

    private addNewNames(row: any): void {
        const kk_field = this.categoryFieldNames.kk;
        const ru_field = this.categoryFieldNames.ru;
        const kk_text = row[kk_field];
        const ru_text = row[ru_field];

        const kk_newText = kk_text ? `${kk_text} - көшірмесі` : '';
        const ru_newText = ru_text ? `${ru_text} - копия` : '';
        const orderNumber = this.getOrderNumber(kk_newText, ru_newText);
        row[kk_field] = kk_text ? kk_newText + orderNumber : '';
        row[ru_field] = ru_text ? ru_newText + orderNumber : '';
    }

    private getOrderNumber(kk_newText: string, ru_newText: string): number {
        let maxOrderNumber = 0;
        const kk_field = this.categoryFieldNames.kk;
        const ru_field = this.categoryFieldNames.ru;
        const fileredBudgetForm = this.budgetForm.filter((item: any) => {
            return item[kk_field].startsWith(kk_newText) && item[ru_field].startsWith(ru_newText);
        })

        if (fileredBudgetForm.length > 0) {
            fileredBudgetForm.forEach((item: any) => {
                const orderNumberStr = item[ru_field].slice(ru_newText.length);
                if (orderNumberStr.length > 0 && this.isNumber(orderNumberStr)) {
                    const orderNumber = Number(orderNumberStr);
                    if (orderNumber > maxOrderNumber) maxOrderNumber = orderNumber;
                }
            })
        }

        return maxOrderNumber + 1;
    }

    private isNumber(str: string): boolean {
        return /^[+-]?\d+(\.\d+)?$/.test(str);
    }
    private async saveCopiedRows(newBudgetForm: any) {
        this.copyBtnDisabled = true;
        const data = {
            newBudgetForm: newBudgetForm,
            header: {...this.header, isPaidTab: this.isPaidTab},
            categoryFieldNames: this.categoryFieldNames
        }
        try {
            const response = await fetch('/api-py/budget-request-copy-rows/',
                {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(data)
                });
            const result = await response.json();
            if (response.ok && result.result === 'success') {
                this.$emit('reloadTable');
                this.makeToast('success', this.getErrText('msg'), this.getText('copied_successfuly'));
            }
            else {
                this.makeToast('danger', `${this.getErrText('bad_request')} saveCopiedRows()`, `Error code: ${response.status}`);
            }
        } catch (error) {
            this.makeToast('danger', `${this.getErrText('bad_request')} saveCopiedRows()`, error.toString());
        } finally {
            this.setCopyBtnDisabled(false);
        }
    }

    public setCopyBtnDisabled(val: boolean): void {
        this.copyBtnDisabled = val;
    }
    
}
